export default {
  loading: {
    en: 'Loading',
    fi: 'Ladataan',
    sv: 'Laddas'
  }
};